module.exports = __webpack_public_path__ + "img/sinalco.96d0dbcb.png";